import { getVibesTreatment } from "src/shared/getMetaData";

export type featureEnabled = () => Promise<boolean>;

export const eventsEnabled = async (): Promise<boolean> => {
    return true;
};

// This is the same feature flag as event service, but named differently in case we need to split the flags later
export const eligibilityServiceEnabled = async (): Promise<boolean> => {
    return eventsEnabled();
};

export async function getVibesFeatureFlag(): Promise<string> {
    // if the document has passed the loading state, we can get the treatment from the DOM
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        return getVibesTreatment(window.document);
    }

    // if the document isn't beyond the loading state, then we can add a ready state change listener
    return new Promise((resolve) => {
        document.addEventListener('readystatechange', (event) => {
            const readyState = (event.target as Document).readyState;
            if (readyState === 'complete' || readyState === 'interactive') {
                resolve(getVibesTreatment(window.document));
            }
        });
    });
}